import React, { useState } from 'react';
import { auth } from '../config/firebase';
import {
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  sendEmailVerification
} from 'firebase/auth';
import { useNavigate } from 'react-router-dom';

export default function LoginPage() {
  const [isSignUp, setIsSignUp] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [verificationSent, setVerificationSent] = useState(false);
  const navigate = useNavigate();

  const handleAuth = async (e) => {
    e.preventDefault();
    setError('');
    try {
      if (isSignUp) {
        const result = await createUserWithEmailAndPassword(auth, email, password);
        await sendEmailVerification(result.user);
        setVerificationSent(true);
      } else {
        const result = await signInWithEmailAndPassword(auth, email, password);
        if (!result.user.emailVerified) {
          setError('Please verify your email before logging in. Check your inbox!');
          await auth.signOut();
          return;
        }
        navigate('/dashboard');
      }
    } catch (err) {
      setError(err.message.replace('Firebase: ', ''));
    }
  };

  if (verificationSent) return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.logo}>Listlytics</h1>
        <div style={styles.verifyBox}>
          <p style={styles.verifyIcon}>📧</p>
          <h2 style={styles.verifyTitle}>Check your email!</h2>
          <p style={styles.verifyText}>
            We sent a verification link to <strong>{email}</strong>.
            Click the link in the email to activate your account.
          </p>
          <button style={styles.button} onClick={() => setVerificationSent(false)}>
            Back to Login
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.logo}>Listlytics</h1>
        <p style={styles.subtitle}>{isSignUp ? 'Create your account' : 'Welcome back'}</p>
        {error && <p style={styles.error}>{error}</p>}
        <form onSubmit={handleAuth}>
          <input style={styles.input} type="email" placeholder="Email"
            value={email} onChange={e => setEmail(e.target.value)} required />
          <input style={styles.input} type="password" placeholder="Password (min 6 characters)"
            value={password} onChange={e => setPassword(e.target.value)} required />
          <button type="submit" style={styles.button}>
            {isSignUp ? 'Create Account' : 'Log In'}
          </button>
        </form>
        {!isSignUp && (
          <p style={styles.forgotPassword}>
            <span style={styles.toggleLink} onClick={() => navigate('/forgot-password')}>
              Forgot password?
            </span>
          </p>
        )}
        <p style={styles.toggle}>
          {isSignUp ? 'Already have an account?' : "Don't have an account?"}{' '}
          <span style={styles.toggleLink} onClick={() => setIsSignUp(!isSignUp)}>
            {isSignUp ? 'Log in' : 'Sign up'}
          </span>
        </p>
      </div>
    </div>
  );
}

const styles = {
  container: { minHeight: '100vh', display: 'flex', alignItems: 'center',
    justifyContent: 'center', background: '#f5f5f5', fontFamily: 'sans-serif' },
  card: { background: '#fff', borderRadius: 16, padding: 32, width: '100%',
    maxWidth: 400, boxShadow: '0 4px 20px rgba(0,0,0,0.08)' },
  logo: { fontSize: 28, fontWeight: 'bold', textAlign: 'center',
    margin: '0 0 8px', color: '#2E86AB' },
  subtitle: { textAlign: 'center', color: '#666', margin: '0 0 24px' },
  error: { background: '#fee', color: '#c00', padding: 10, borderRadius: 8,
    fontSize: 14, marginBottom: 16 },
  input: { width: '100%', padding: 12, marginBottom: 12, fontSize: 15,
    border: '1px solid #ddd', borderRadius: 8, boxSizing: 'border-box' },
  button: { width: '100%', padding: 14, background: '#2E86AB', color: '#fff',
    border: 'none', borderRadius: 8, fontSize: 16, fontWeight: 'bold',
    cursor: 'pointer', marginBottom: 16 },
  forgotPassword: { textAlign: 'center', fontSize: 14, margin: '0 0 12px' },
  toggle: { textAlign: 'center', fontSize: 14, color: '#666', margin: 0 },
  toggleLink: { color: '#2E86AB', cursor: 'pointer', fontWeight: 'bold' },
  verifyBox: { textAlign: 'center' },
  verifyIcon: { fontSize: 48, margin: '0 0 12px' },
  verifyTitle: { fontSize: 22, fontWeight: 'bold', margin: '0 0 12px' },
  verifyText: { fontSize: 15, color: '#555', lineHeight: 1.6, margin: '0 0 24px' },
};
